export const AUTH_STORAGE_KEYS = {
  accessToken: 'accessToken',
  user: 'user',
} as const

export const AUTH_SESSION_KEYS = {
  postLoginRedirect: 'postLoginRedirect',
} as const
